<div class="ev-switch-track">
  <div class="ev-switch-thumb" #thumb>
    @if (activeSvg(); as icon) {
      <img [src]="icon" class="ev-switch-thumb-icon" alt="thumb"/>
    }
  </div>
</div>
